var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileExplorer = function SvgFileExplorer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 14 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#868E96",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M12.833 8.542H8.166m4.667 1.75H8.166m2.334 1.75H8.167M4.083 3.292h5.688c1.229 0 1.843 0 2.284.295.191.127.356.291.483.483.295.441.295 1.201.295 2.43M7 3.292l-.37-.74c-.306-.611-.586-1.228-1.264-1.482C5.07.958 4.73.958 4.051.958c-1.06 0-1.59 0-1.987.222a1.75 1.75 0 0 0-.676.676c-.221.397-.221.927-.221 1.987v1.782c0 2.75 0 4.125.854 4.98.758.758 1.927.843 4.104.852"
  })));
};
export default SvgFileExplorer;